'use client';

import { c as _c } from "react/compiler-runtime";
import { RiskDisclosureLoading } from '../RiskDisclosure/states';
import { VaultRiskDisclosuresLayout } from '../VaultRiskDisclosuresLayout';
const VaultRiskLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VaultRiskDisclosuresLayout><RiskDisclosureLoading /></VaultRiskDisclosuresLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultRiskLoading;